export const STATUS_WORDS = [
  "SYNCING",
  "RECALIBRATING",
  "STAND BY",
  "RE-INDEXING",
  "ERR::0x9F",
  "▓▓ UNSTABLE",
  "LOCKING ORBIT",
  "BUFFERING",
];
export const GLITCH_GLYPHS = "▓█▚▞#%*?0123456789";

export function seedCountdown(rand: () => number = Math.random): number {
  return 27 * 86400 + Math.floor(rand() * 10 * 86400) + Math.floor(rand() * 86400);
}

export function fmtDuration(sec: number): string {
  sec = Math.max(0, Math.floor(sec));
  const d = Math.floor(sec / 86400);
  sec -= d * 86400;
  const h = Math.floor(sec / 3600);
  sec -= h * 3600;
  const m = Math.floor(sec / 60);
  const s = sec - m * 60;
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d)}:${p(h)}:${p(m)}:${p(s)}`;
}

export function tickCountdown(cd: number, gi: number, rand: () => number = Math.random): number {
  const r = rand();
  if (r < 0.02 + 0.1 * gi) cd += Math.floor(rand() * 520) + 40;
  else if (r < 0.06 + 0.16 * gi) cd -= Math.floor(rand() * 400) + 80;
  else cd -= 1;
  if (cd < 0) cd = 20 * 86400 + Math.floor(rand() * 12 * 86400);
  if (cd > 60 * 86400) cd = 60 * 86400;
  return cd;
}

export function flickerString(base: string, gi: number, rand: () => number = Math.random): string {
  let out = "";
  for (let i = 0; i < base.length; i++) {
    const ch = base[i];
    if (ch === ":") {
      out += ch;
      continue;
    }
    out += rand() < 0.03 + 0.2 * gi ? GLITCH_GLYPHS[Math.floor(rand() * GLITCH_GLYPHS.length)] : ch;
  }
  return out;
}
